export const Profile_URL = process.env.REACT_APP_PROFILE_URL;
export const Auth_URL = process.env.REACT_APP_AUTH_URL;
export const Shop_URL = process.env.REACT_APP_SHOP_URL;
export const Chat_URL = process.env.REACT_APP_CHAT_URL;
export const Reports_URL = process.env.REACT_APP_REPORTS_URL;
export const TeleConsultation_URL = process.env.REACT_APP_TELECONSULTATION_URL;
export const Websocket_URL = process.env.REACT_APP_WEBSOCKET_URL;
export const clinicalModel_URL = process.env.REACT_APP_CLINICAL_URL;
export const report_URL = process.env.REACT_APP_REPORT_URL;
export const clinicalModel2_URL = process.env.REACT_APP_CLINICAL_URL2;